module.exports = __webpack_public_path__ + "static/media/for-startups-passion.47174faa.jpg";